export type DealLifecycle = {
    status?: string;
    soldDate?: string;
    approvedDate?: string;
    contractSignedDate?: string;
    deliveredDate?: string;
    updateDealLifecycleStatus: UpdateDealLifecycleStatus;
    dmsHandOffDate?: string;
    showDealLifeCycleModal?: boolean;
    showDealLifeCycleModalLoader?: boolean;
    createdOn?: string;
    hasContractSignDateUpdated?: boolean;
    finalizedDate?: string;
    unwoundDate?: string;
};

export enum UpdateDealLifecycleStatus {
    Ready = 'ready',
    Sending = 'sending',
    Success = 'success',
    Failure = 'failure'
}
